<template>
  <van-overlay show z-index="1000">
    <div class="text-white text-medium pt-10 relative">
      <div class="text-center text-lg">
        <span>请用微信识别下方二维码登记领奖</span>
      </div>
      <template v-if="isTest">
        <div class="text-center text-red">
          <span> (测试答题，不真实发放红包)</span>
        </div>
      </template>
      <div class="text-center">
        <div class="mt-4">
          <vue-qr :text="url" />
        </div>
        <div class="mt-2">
          <span>15分钟有效，请尽快扫码</span>
        </div>
      </div>
      <div class="text-center text-large mt-5 leading-base">
        <template v-if="needAuditFlag">
          <div>
            <span>红包由</span>
            <span class="text-red">问卷发布者负责审核发放</span>
            <span>，请耐心等待</span>
          </div>
        </template>
        <span>如有疑问，请联系问卷发布者</span>
      </div>
      <ul class="px-5 mt-5 leading-base">
        <li class="mb-2">长按识别二维码方法：</li>
        <li class="mb-2">1.长按保存（或截屏）当前图片到相册；</li>
        <li class="mb-2">2.进入微信->扫一扫->识别相册中的二维码；</li>
        <li class="mb-2">3.即可在打开页面中查看领奖记录；</li>
        <li class="">4.在微信中搜索关注“调研工厂+”，可随时查询领奖励情况。</li>
      </ul>

      <span class="absolute" style="top: 40px; right: 16px" @click="$emit('close')">
        <van-icon name="cross" class="text-large" />
      </span>
    </div>
  </van-overlay>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'ReceiveReward',
  components: { VueQr },
  props: {
    isTest: {
      type: Boolean,
      default: false
    },
    needAuditFlag: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>
